import { notifiableValue } from '../notifiableValue';

/**
 * The reason Piezo provisioning last failed, or undefined if it worked.
 *
 * Init returns its failure rather than throwing and the page-load caller only logs it, so this is what
 * lets the navbar say signing is unavailable before a tool call does.
 */
const failure = notifiableValue<string | undefined>(undefined);

export function recordPiezoInitFailure(reason: string): void {
  failure.set(reason);
}

/** Called on a provision that produced usable material, including one served from the cache. */
export function clearPiezoInitFailure(): void {
  failure.set(undefined);
}

export function getPiezoInitFailure(): string | undefined {
  return failure.get();
}

export const onPiezoInitStatusChange = failure.onChange;

/** Whether a provision is fetching from the network, the slow path, so the navbar can show signing is starting. */
const inProgress = notifiableValue(false);

export function setPiezoInitInProgress(value: boolean): void {
  inProgress.set(value);
}

export function isPiezoInitInProgress(): boolean {
  return inProgress.get();
}

export const onPiezoInitProgressChange = inProgress.onChange;
